import { useMemo } from "react";
import { Provider } from "react-redux";
import GabbiAiSettings from "./GabbiAiSettings";

const GabbiAISettingsApp = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Provider store={store}>
      <GabbiAiSettings />
    </Provider>
  );
};

export default GabbiAISettingsApp;
